<li id="group-{{id}}" class="group {{key}} {{status}} {{lockState}} {{dateStatus}}" >
  <a href="#{{#if unlocked}}{{linkPath}}{{/if}}" class="group-link"></a>
</li>
